export default $axios => resource => ({
  fetchCampsiteExtras(payload) {
    return $axios.get(`${resource}/extras`, { params: payload })
  },
  updateCampsiteExtras(payload) {
    return $axios.post(`${resource}/extras`, payload)
  },
})
